import React from "react";
import PropTypes from "prop-types";
import Card from "UI/Card";
import Feature from "Components/Feature";
import { Facebook, Twitter, Instagram } from "Components/Icons";
import Badge from "UI/Badge";

export default class ChooseIntegrationPanel extends React.Component
{
    static propTypes = {
        next: PropTypes.func.isRequired
    };

    render()
    {
        return <div className='space-y-4'>
            <p>
                Please select your integration below:
            </p>
            <div className='grid grid-cols-3 gap-4'>
                <button onClick={() => this.props.next('facebook')}>
                    <Card>
                        <Facebook />
                    </Card>
                </button>

                <button onClick={() => this.props.next('twitter')}>
                    <Card className='relative'>
                        <Twitter />
                    </Card>
                </button>

                <Card className='relative'>
                    <Instagram />
                    <Badge className='absolute top-2 right-2'>Coming soon</Badge>
                </Card>
            </div>
        </div>;
    }
}